var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-bell-notification"},[(_vm.isHover || _vm.isOpened)?_c('img',{attrs:{"src":require("../../assets/bell-notification-opened.svg"),"width":"18px","height":"18px"}}):_c('img',{attrs:{"src":require("../../assets/bell-notification.svg"),"width":"18px","height":"18px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }